import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { PENDING_CODE, PENDING_LEVEL } from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { applyAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const invitation_code = localStorage.getItem(PENDING_CODE) || undefined;
        const target_level = localStorage.getItem(PENDING_LEVEL) || undefined;
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, invitation_code, target_level });
        localStorage.removeItem(PENDING_CODE); localStorage.removeItem(PENDING_LEVEL);
        const u = applyAuth(data);
        nav(u.onboarded ? "/dashboard" : "/onboarding", { replace: true, state: { user: u } });
      } catch (e) {
        toast.error(errMsg(e, "Login Google gagal"));
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, applyAuth]);

  return <div className="flex min-h-screen items-center justify-center bg-paper text-sm text-muted-foreground" data-testid="auth-callback">…</div>;
}
